"use client";
import React, {useCallback} from 'react';
import {ErrorBoundary} from 'react-error-boundary';
import {Stack, Typography} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import RefreshIcon from '@mui/icons-material/Refresh';
import CONFIG from '../config.js';
import Image from './Image.js';
import SCButton from './SCButton.js';

const ErrorComp = ()=><Stack direction="row" justifyContent="center"
  alignItems="center" gap={4} sx={{margin: '40px'}}>
  <Image imagekit_src="magic-wand.svg" maxWidth="100px"/>
  <Stack direction="column" gap={2}>
    <Typography variant="h2">
      אופסי...
    </Typography>
    <Typography variant="h6">
      נראה שאירעה שגיאה והקסם לא צלח 😔
    </Typography>
    <Stack direction="row" gap={2}>
      <SCButton text="ריענון העמוד" variant="contained" size="large"
        onClick={()=>window.location.reload()} icon={<RefreshIcon/>} iconPlacement="right"/>
      <SCButton text="חזרה לדף הבית" variant="contained" size="large"
        onClick={()=>{ window.location.href = '/'; }} icon={<HomeIcon/>} iconPlacement="right"/>
    </Stack>
  </Stack>
</Stack>;

const AppErrorBoundary = props=>{
    let {children} = props;
    let onError = useCallback((error, {componentStack})=>{
        fetch(CONFIG.API_BASE+'log_ui_error', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                error: error.message,
                stack: error.stack,
                componentStack: componentStack,
                url: window.location.href,
            }),
        });
    }, []);
    return <ErrorBoundary FallbackComponent={ErrorComp} onError={onError}>
      {children}
    </ErrorBoundary>;
};

export default AppErrorBoundary;
